// extracted by mini-css-extract-plugin
export default {"userImageContainer":"style_userImageContainer__JEySB"};